// extracted by css-extract-rspack-plugin
export default {"currency__icon":"currency__icon-s5Cpir","currencyIcon":"currency__icon-s5Cpir","vcfc":"vcfc-yeAY4z"};